export default __webpack_public_path__ + "users-white-icon.svg";